import { useMemo } from 'react';
import useShowAccountValues from 'src/hooks/useShowAccountValues';
import formatNumber from 'src/utils/formatNumber/formatNumber';
import {
	FormatNumberOptions,
	FormatNumberValue,
} from 'src/utils/formatNumber/types';

interface Params extends FormatNumberOptions {
	value: FormatNumberValue;
}

export default function useNumberDisplay({
	value,
	type,
	millify,
	decimals,
	precision,
	trimZeroes,
	suffix,
	surround,
	fallback,
}: Params) {
	const showAccountValues = useShowAccountValues();

	const valueMemoKey = `${value?.val.toString()}:${value?.precision.toString()}`;

	const formattedValue = useMemo(() => {
		return formatNumber(value, {
			type,
			millify,
			decimals,
			precision,
			trimZeroes,
			suffix,
			surround,
			fallback,
		});
	}, [
		valueMemoKey,
		type,
		millify,
		decimals,
		precision,
		trimZeroes,
		suffix,
		surround,
		fallback,
	]);

	return { formattedValue, showAccountValues };
}
